import core from './core';
var dataRelay = core(null, 'JavaScript SDK');
export default dataRelay;
